import {RichBlockType} from '../../../types/api.ts';
import VideoBlock from './VideoBlock.tsx';
import {FC} from 'react';
import TextBlock from './TextBlock.tsx';
import ImageBlock from './ImageBlock.tsx';
import DocumentBlock from './DocumentBlock.tsx';
import {PreviewProfileProps} from '../types.ts';
import ImagesBlock from './ImagesBlock.tsx';

export const blockComponents: Record<
    RichBlockType,
    FC<RichBlockComponentProps<any>>
> = {
    [RichBlockType.Video]: VideoBlock,
    [RichBlockType.Image]: ImageBlock,
    [RichBlockType.Images]: ImagesBlock,
    [RichBlockType.Text]: TextBlock,
    [RichBlockType.Document]: DocumentBlock,
};

export type RichBlockComponentProps<D = Record<string, any>> = {
    data: D;
    locale: string | undefined;
} & PreviewProfileProps;
